import React, { useContext, useEffect, useState } from "react";
import "../../../TutorGreen.css";
import toast from "react-hot-toast";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { AuthContextTwo } from "../../../../../../contexts/AuthProviderTwo";
import { initializeApp } from "firebase/app";
import { Link } from "react-router-dom";
import LoaderSmall from "../../../../../Shared/LoderSmall/LoaderSmall";

const firebaseConfig = {
  apiKey: "AIzaSyDHqLpPVzd0Y9SWTpSH1smRmbKv4WUvi-4",
  authDomain: "tutors-today-student.firebaseapp.com",
  projectId: "tutors-today-student",
  storageBucket: "tutors-today-student.appspot.com",
  messagingSenderId: "171808622362",
  appId: "1:171808622362:web:cb9ad091e01bba89988ea3",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

const ModalPersonalMobile = ({ isVisible, onClose, profileData }) => {
  const { userTwo } = useContext(AuthContextTwo);
  const [loading, setLoading] = useState(false);
  const [selectedLocation, setLocation] = useState(null);
  const [selectedAreaTwo, setAreaTwo] = useState(null);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    religion: "",
    fileUrl: "",
    city: "",
    area: "",
    emergencyNmbr: "",
  });

  //////////////////// Profile Data  start /////////////////////////

  const [isNameValid, setIsNameValid] = useState(
    profileData.area ||
      profileData.gender ||
      profileData.city ||
      profileData.emergencyNmbr
      ? true
      : false
  );
  const [uploadAttempted, setUploadAttempted] = useState(false);

  // Update useEffect to set isNameValid when profileData changes
  useEffect(() => {
    if (
      profileData.area ||
      profileData.gender ||
      profileData.city ||
      profileData.emergencyNmbr
    ) {
      setIsNameValid(true);
    }
  }, [profileData]);
  //////////////////// Profile Data  end   /////////////////////////
  const handleFileChange = (event) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles.length > 0) {
      const fileLabels = Array.from(uploadedFiles)
        .map((file) => file.name)
        .join(", ");
      document.getElementById("fileLabel").innerText = fileLabels;
      setFile(Array.from(uploadedFiles));
    } else {
      document.getElementById("fileLabel").innerText = "JPG / PNG / PDF";
      setFile([]);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const [isCityValid, setIsCityValid] = useState(true);
  const [isAreaValid, setIsAreaValid] = useState(true);
  const [isGenderValid, setIsGenderValid] = useState(true);
  const [isEmergencyNmbrValid, setIsEmergencyNmbrValid] = useState(true);

  const handleUpload = async () => {
    setLoading(true);
    setUploadAttempted(true); // Set that an upload attempt has been made

    // Check if name is required and not provided
    const isAnyProfileValid = profileData.some(
      (profile) =>
        profile.area && profile.gender && profile.city && profile.emergencyNmbr
    );

    const isFormDataValid =
      formData.area &&
      formData.gender &&
      formData.city &&
      formData.emergencyNmbr;
    // If no profile is valid, show an error and stop execution

    setIsCityValid(formData.city || profileData.city);
    setIsAreaValid(formData.area || profileData.area);
    setIsGenderValid(formData.gender || profileData.gender);
    setIsEmergencyNmbrValid(
      formData.emergencyNmbr || profileData.emergencyNmbr
    );

    if (
      !isCityValid ||
      !isAreaValid ||
      !isGenderValid ||
      !isEmergencyNmbrValid
    ) {
      setLoading(false);
      return;
    }
    if (!isAnyProfileValid && !isFormDataValid) {
      toast.error("Please fill up all the required fields.");
      setLoading(false);
      return; // Stop further execution
    }

    setIsNameValid(true); // Name is valid

    const updatedFormData = { ...formData };

    // Assuming you have a file upload process here
    if (file && file.length > 0) {
      const promises = [];

      file.forEach((uploadedFile, index) => {
        const storageRef = ref(storage, `uploads/${uploadedFile.name}`);
        promises.push(
          uploadBytes(storageRef, uploadedFile)
            .then((snapshot) => getDownloadURL(snapshot.ref))
            .then((downloadURL) => {
              updatedFormData[`fileUrl${index + 1}`] = downloadURL;
              return downloadURL;
            })
        );
      });

      try {
        await Promise.all(promises);
        console.log("Files uploaded successfully!");
      } catch (error) {
        console.error("Error uploading files: ", error);
        setLoading(false);
        return; // Stop further execution if file upload fails
      }
    }

    try {
      // Update the formData state
      setFormData(updatedFormData);

      // Assuming you have a function to update data on the server
      await updateDataOnServer(updatedFormData);

      // Display a success message to the user
      toast.success("Data submitted successfully!");
    } catch (error) {
      console.error("Error submitting form: ", error);
      toast.error("Error submitting data");
    } finally {
      setLoading(false);
    }
  };

  const updateDataOnServer = async (dataToUpdate) => {
    try {
      const updateResponse = await fetch(
        "https://tutor-tree-server-1.vercel.app/user/updateImage",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userTwo.email,

            ...dataToUpdate,
          }),
        }
      );

      const updateData = await updateResponse.json();
      onClose()
      console.log("Data updated on the server:", updateData);

    } catch (error) {
      console.error("Error updating data on the server:", error);
    }
  };
  // Adjust the dropdown to have the name "district"

  ////////////////////////////////// khulna and chittagong area start ///////////////////////////////
  const [districts, setDistricts] = useState([]);

  const fetchDistricts = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allDistrict");
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  const [KhulnaArea, setKhulnaArea] = useState([]);
  const fetchKhulnaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
      const data = await response.json();
      setKhulnaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchKhulnaArea();
  }, []);
  const [ChittagongArea, setChittagongArea] = useState([]);
  const fetchChittagongArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
      const data = await response.json();
      setChittagongArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchChittagongArea();
  }, []);

  const [DhakaArea, setDhakaArea] = useState([]);
  const fetchDhakaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
      const data = await response.json();
      setDhakaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDhakaArea();
  }, []);
  if (!isVisible) return null; // Render nothing if the modal is not visible

  return (
    <div
      className="fixed inset-0  bg-opacity-75 flex justify-center items-center z-50"
      style={{ backdropFilter: "blur(5px)" }}
    >
      <div className="bg-white rounded-lg shadow-custom-full w-full mx-5 ">
        <div className="flex justify-between py-3 px-5 items-center border-b shadow-md border-green-300">
          <h1 className="text-green-900 text-md font-montserrat modalTitle">
          Edit Personal Information
          </h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      
        <div className="bg-green-100 py-5 h-[350px] overflow-y-auto">

          {profileData.map((profile) => (
            <div className="grid lg:grid-cols-3 sm:grid-cols-1 gap-2 px-3">
              <div>
                <div className="text-green-900 text-md font-montserrat text600">
                  Full Name
                </div>
                <input
                  type="text"
                  name="name"
                  placeholder={profile.name}
                  className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                  onChange={handleInputChange}
                />
             
              </div>
              <div className="">
                <div className="text-green-900 text-md font-montserrat text600">
                  Select City *
                </div>

                <select
                  required
                  name="city"
                  value={selectedLocation}
                  onChange={(e) => {
                    handleInputChange(e);
                    setLocation(e.target.value);
                  }}
                  className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                >
                  <option disabled selected>
                    {profile.city}
                  </option>
                  {districts.map((district, index) => (
                    <option key={index} value={district.district}>
                      {district.district}
                    </option>
                  ))}
                </select>
                <div>
                  {!isCityValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      "City is required"
                    </div>
                  )}
                </div>
              </div>
              <div className="">
                {selectedLocation === "Chittagong" && (
                  <div>
                    <div className="text-green-900 text-md font-montserrat text600">
                      Select Area *
                    </div>
                    <select
                      name="area"
                      className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                      onChange={(e) => {
                        handleInputChange(e);
                        setAreaTwo(e.target.value);
                      }}
                    >
                      <option disabled selected>
                        {profile.area}
                      </option>
                      {ChittagongArea.map((area, index) => (
                        <option key={index} value={selectedAreaTwo}>
                          {area.area}
                        </option>
                      ))}
                    </select>
                    <div>
                      {!isAreaValid && (
                        <div className="text-red-500 text-sm mt-1 textAlert">
                          {profile.area ? "" : "Area is required"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {selectedLocation === "Khulna" && (
                  <div>
                    <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
                      Select Location
                    </div>
                    <select
                      name="area"
                      className="h-[60px] select border-2 border-orange-500 select-error w-full"
                      onChange={(e) => {
                        handleInputChange(e);
                        setAreaTwo(e.target.value);
                      }}
                    >
                      <option disabled selected>
                        {profile.area}
                      </option>
                      {KhulnaArea.map((area, index) => (
                        <option key={index} value={selectedAreaTwo}>
                          {area.area}
                        </option>
                      ))}
                    </select>
                    <div>
                      {!isAreaValid && (
                        <div className="text-red-500 text-sm mt-1 textAlert">
                          {profile.area ? "" : "Area is required"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {selectedLocation === "Dhaka" && (
                  <div>
                    <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
                      Select Location
                    </div>
                    <select
                      name="area"
                      className="h-[60px] select border-2 border-orange-500 select-error w-full"
                      onChange={(e) => {
                        handleInputChange(e);
                        setAreaTwo(e.target.value);
                      }}
                    >
                      <option disabled selected>
                        {profile.area}
                      </option>
                      {DhakaArea.map((area, index) => (
                        <option key={index} value={selectedAreaTwo}>
                          {area.area}
                        </option>
                      ))}
                    </select>
                    <div>
                      {!isAreaValid && (
                        <div className="text-red-500 text-sm mt-1 textAlert">
                          {profile.area ? "" : "Area is required"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div>
                <div className="text-green-900 text-md font-montserrat text600">
                  Gender *
                </div>

                <select
                  name="gender"
                  onChange={handleInputChange}
                  className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                >
                  <option disabled selected>
                    {profile.gender}
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
                <div>
                  {!isGenderValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      {profile.gender ? "" : "Gender is required"}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className="text-green-900 text-md font-montserrat text600">
                  Religion
                </div>

                <select
                  name="religion"
                  onChange={handleInputChange}
                  className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                >
                  <option disabled selected>
                    {profile.religion}
                  </option>
                  <option value="Islam">Islam</option>
                  <option value="Hinduism">Hinduism </option>
                  <option value="Buddhism">Buddhism</option>
                  <option value="Christianity">Christianity</option>
                </select>
              </div>
              <div>
                <div className="text-green-900 text-md font-montserrat text600">
                  Emergency Contact Number *
                </div>
                <input
                  type="number"
                  name="emergencyNmbr"
                  placeholder={profile.emergencyNmbr}
                  className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                  onChange={handleInputChange}
                />
                {!isEmergencyNmbrValid && (
                  <div className="text-red-500 text-sm mt-1 textAlert">
                    {profile.emergencyNmbr ? "" : "Emergency Number required"}
                  </div>
                )}
              </div>
              <div>
                <div className="text-green-900 text-md font-montserrat text600">
                  NID / Birth Certificate
                </div>

                <div 

                className="border mt-2 border-green-900 rounded h-12  bg-white items-center font-montserrat text-green-600 flex justify-between px-5 ">
                  <div>
                    <input
                      type="file"
                      id="fileInput"
                      accept=".pdf, .jpg, .jpeg, .png, .gif, .mp4, .webm"
                      onChange={handleFileChange}
                      
                      style={{ display: "none" }}
                      multiple
                    />
                    <button
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      <h1 className=" text-sm" id="fileLabel">
                        JPG / PNG / PDF
                      </h1>
                    </button>
                  </div>

                  <div className="flex flex-row items-center">
                    <button
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      <img className="w-5" alt="" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjMDA4MDAwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PC9nPjwvc3ZnPg==" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
        </div>
        <div className="flex  mx-5">
            <div>
              {loading ? (
                <button
                  onClick={handleUpload}
                  className="lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-green-700 font-montserrat text-white rounded my-5"
                >
                  <LoaderSmall />
                </button>
              ) : (
                // Show the loader when uploading
                <button
                  onClick={handleUpload}
                  className="lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-green-700 font-montserrat text-white rounded my-5"
                >
                  Submit
                </button>
              )}
            </div>
            
        </div>
      </div>
    </div>
  );
};

export default ModalPersonalMobile;
